import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "documents roba-container flex" }
const _hoisted_2 = { class: "filters-left flex flex-column mr-2" }
const _hoisted_3 = { class: "white pa-2" }
const _hoisted_4 = { class: "mb-05" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "mb" }
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "documents-checkbox__label" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "white pa-2 mt-2" }
const _hoisted_11 = { class: "documents-date-field" }
const _hoisted_12 = { class: "documents-date-field__label" }
const _hoisted_13 = { class: "documents-date-field__control" }
const _hoisted_14 = { class: "documents-date-field mt" }
const _hoisted_15 = { class: "documents-date-field__label" }
const _hoisted_16 = { class: "documents-date-field__control" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "filters-top white mb-2" }
const _hoisted_20 = { class: "filters-top__search pa-2" }
const _hoisted_21 = {
  class: "documents-select-wrapper",
  ref: "searchTypeMenuRoot"
}
const _hoisted_22 = { class: "documents-select__label" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "documents-search" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = {
  key: 1,
  class: "documents-search__icon"
}
const _hoisted_28 = { class: "filters-top__actions pa-2" }
const _hoisted_29 = {
  class: "documents-sort",
  ref: "sortMenuRoot"
}
const _hoisted_30 = { class: "documents-sort__label" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  class: "documents-content",
  key: "content"
}
const _hoisted_33 = {
  class: "loader",
  key: "loader"
}
const _hoisted_34 = {
  class: "no-results",
  key: "no-results"
}
const _hoisted_35 = { key: "overview" }
const _hoisted_36 = {
  key: 0,
  class: "documents-pagination mb"
}
const _hoisted_37 = ["disabled", "aria-label"]
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = ["disabled", "aria-label"]
const _hoisted_40 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = { class: "ml" }
const _hoisted_43 = {
  key: 1,
  class: "documents-sheet-overlay"
}
const _hoisted_44 = { class: "documents-sheet" }
const _hoisted_45 = {
  key: 2,
  class: "documents-sheet-overlay"
}
const _hoisted_46 = { class: "documents-sheet" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_document_block = _resolveComponent("document-block")!
  const _component_selected_documents = _resolveComponent("selected-documents")!
  const _component_document_version_details = _resolveComponent("document-version-details")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('COMMON.FILTERS')), 1),
        _createElementVNode("button", {
          class: "clear-button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAllFilters && _ctx.clearAllFilters(...args))),
          disabled: _ctx.documentTypeFilter.length === 0 && !_ctx.fromDate && !_ctx.untilDate
        }, _toDisplayString(_ctx.$t('COMMON.CLEAR_ALL_FILTERS')), 9, _hoisted_5),
        _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "mb-05 mt" }, null, -1)),
        _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('DOCUMENTS.DOCUMENT_TYPE')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypes, (type) => {
          return (_openBlock(), _createElementBlock("label", {
            class: "documents-checkbox",
            key: type.id
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.documentTypeFilter.includes(type.value),
              onChange: ($event: any) => (_ctx.toggleDocumentTypeFilter(type.value, $event))
            }, null, 40, _hoisted_7),
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "documents-checkbox__box" }, null, -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(type.titleKey)), 1)
          ]))
        }), 128)),
        _createElementVNode("button", {
          class: "clear-button mt",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearDocumentTypeFilter && _ctx.clearDocumentTypeFilter(...args))),
          disabled: _ctx.documentTypeFilter.length === 0
        }, _toDisplayString(_ctx.$t('COMMON.CLEAR_FILTERS')), 9, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('COMMON.DATE_FROM')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_VueDatePicker, {
              class: "documents-datepicker",
              modelValue: _ctx.fromDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fromDate) = $event)),
              "model-type": "yyyy-MM-dd",
              "text-input": { format: "dd-MM-yyyy" },
              "auto-apply": "",
              "time-config": { enableTimePicker: false },
              clearable: false,
              teleport: false,
              placeholder: ""
            }, null, 8, ["modelValue"]),
            _cache[24] || (_cache[24] = _createElementVNode("i", { class: "icons8-sort-down documents-date-field__chevron" }, null, -1))
          ])
        ]),
        _createElementVNode("label", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('COMMON.DATE_UNTIL')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_VueDatePicker, {
              class: "documents-datepicker",
              modelValue: _ctx.untilDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.untilDate) = $event)),
              "model-type": "yyyy-MM-dd",
              "text-input": { format: "dd-MM-yyyy" },
              "auto-apply": "",
              "time-config": { enableTimePicker: false },
              clearable: false,
              teleport: false,
              placeholder: ""
            }, null, 8, ["modelValue"]),
            _cache[25] || (_cache[25] = _createElementVNode("i", { class: "icons8-sort-down documents-date-field__chevron" }, null, -1))
          ])
        ]),
        _createElementVNode("button", {
          class: "clear-button mt",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearDateFilter && _ctx.clearDateFilter(...args))),
          disabled: !_ctx.fromDate && !_ctx.untilDate
        }, _toDisplayString(_ctx.$t('COMMON.CLEAR_FILTERS')), 9, _hoisted_17)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: _normalizeClass(["documents-select", { "is-active": _ctx.showSearchTypeMenu }]),
              type: "button",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSearchTypeMenu && _ctx.toggleSearchTypeMenu(...args)), ["stop"]))
            }, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.currentSearchTypeLabel), 1),
              _createElementVNode("i", {
                class: _normalizeClass(["icons8-sort-down documents-select__chevron", { active: _ctx.showSearchTypeMenu }])
              }, null, 2)
            ], 2),
            (_ctx.showSearchTypeMenu)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "documents-select__menu",
                  onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchTypes, (type) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["documents-select__option", { "is-selected": _ctx.searchType === type.value }]),
                      key: type.id,
                      type: "button",
                      onClick: _withModifiers(($event: any) => (_ctx.applySearchType(type.value)), ["prevent"])
                    }, _toDisplayString(_ctx.$t(type.titleKey)), 11, _hoisted_23))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              class: "documents-search__input",
              type: "text",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: _ctx.searchPlaceholder
            }, null, 8, _hoisted_25), [
              [_vModelText, _ctx.searchQuery]
            ]),
            (_ctx.searchQuery)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "documents-search__clear",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchQuery = "")),
                  "aria-label": _ctx.$t("COMMON.CLEAR_FILTERS")
                }, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("i", { class: "icons8-delete" }, null, -1)
                ]))], 8, _hoisted_26))
              : _createCommentVNode("", true),
            (!_ctx.searchQuery)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[27] || (_cache[27] = [
                  _createElementVNode("i", { class: "icons8-search" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              class: _normalizeClass(["documents-sort__trigger", { "is-active": _ctx.showSortMenu }]),
              type: "button",
              onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleSortMenu && _ctx.toggleSortMenu(...args)), ["stop"]))
            }, [
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('COMMON.SORT_BY')), 1),
              _createElementVNode("i", {
                class: _normalizeClass(["icons8-sort-down documents-sort__chevron", { active: _ctx.showSortMenu }])
              }, null, 2)
            ], 2),
            (_ctx.showSortMenu)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "documents-sort__menu",
                  onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentSortTypes, (sortType) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["documents-sort__option", { "is-selected": _ctx.selectedSortType === sortType.value }]),
                      key: sortType.id,
                      type: "button",
                      onClick: _withModifiers(($event: any) => (_ctx.applySortType(sortType.value)), ["prevent"])
                    }, _toDisplayString(_ctx.$t(sortType.titleKey)), 11, _hoisted_31))
                  }), 128))
                ], 32))
              : _createCommentVNode("", true)
          ], 512),
          _createElementVNode("div", {
            class: _normalizeClass(["view-icon", { "is-active": !_ctx.listView }]),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.listView = false))
          }, [...(_cache[28] || (_cache[28] = [
            _createStaticVNode("<svg fill=\"rgba(0,0,0,0.12)\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" data-v-145ec832><rect x=\"0\" y=\"0\" width=\"8\" height=\"8\" rx=\"1\" data-v-145ec832></rect><rect x=\"12\" y=\"0\" width=\"8\" height=\"8\" rx=\"1\" data-v-145ec832></rect><rect x=\"0\" y=\"12\" width=\"8\" height=\"8\" rx=\"1\" data-v-145ec832></rect><rect x=\"12\" y=\"12\" width=\"8\" height=\"8\" rx=\"1\" data-v-145ec832></rect></svg>", 1)
          ]))], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["view-icon", { "is-active": _ctx.listView }]),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.listView = true))
          }, [...(_cache[29] || (_cache[29] = [
            _createElementVNode("svg", {
              fill: "rgba(0,0,0,0.12)",
              viewBox: "0 0 20 20",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink"
            }, [
              _createElementVNode("rect", {
                x: "0",
                y: "0",
                width: "20",
                height: "4",
                rx: "1"
              }),
              _createElementVNode("rect", {
                x: "0",
                y: "8",
                width: "20",
                height: "4",
                rx: "1"
              }),
              _createElementVNode("rect", {
                x: "0",
                y: "16",
                width: "20",
                height: "4",
                rx: "1"
              })
            ], -1)
          ]))], 2)
        ])
      ]),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_32, [
            (_ctx.isFiltering)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("img", {
                    src: "/loader.svg",
                    alt: "loading..."
                  }, null, -1)
                ]))]))
              : (_ctx.showNoResults)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('COMMON.NO_RESULTS', [_ctx.$t('MENU.DOCUMENTS').toLowerCase()])), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_ctx.showPagination && _ctx.entities.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("button", {
                            class: "documents-pagination__nav",
                            type: "button",
                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goToPreviousPage && _ctx.goToPreviousPage(...args))),
                            disabled: _ctx.currentPage <= 1,
                            "aria-label": _ctx.$t("COMMON.PREVIOUS")
                          }, [...(_cache[31] || (_cache[31] = [
                            _createElementVNode("i", { class: "icons8-back" }, null, -1)
                          ]))], 8, _hoisted_37),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePageTokens, (token, index) => {
                            return (_openBlock(), _createElementBlock("button", {
                              class: _normalizeClass(["documents-pagination__page", { "is-active": token === _ctx.currentPage, "is-ellipsis": token === "..." }]),
                              key: `page-${index}-${token}`,
                              type: "button",
                              disabled: token === "...",
                              onClick: ($event: any) => (_ctx.goToPage(token))
                            }, _toDisplayString(token), 11, _hoisted_38))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "documents-pagination__nav",
                            type: "button",
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.goToNextPage && _ctx.goToNextPage(...args))),
                            disabled: _ctx.currentPage >= _ctx.totalPages,
                            "aria-label": _ctx.$t("COMMON.NEXT")
                          }, [...(_cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "icons8-forward" }, null, -1)
                          ]))], 8, _hoisted_39)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mb-2",
                        key: group.group
                      }, [
                        (group.group === "GROUP_SEARCH_RELATED")
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_40))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t(`DOCUMENTS.${group.group.toUpperCase()}`, _ctx.searchDocumentType ? [_ctx.$t(`ENUM.DOCUMENT_TYPE.${_ctx.searchDocumentType.toUpperCase()}`), _ctx.searchQuery] : [_ctx.searchQuery])), 1),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(group.count) + " " + _toDisplayString(_ctx.$t('COMMON.DOCUMENTS')), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["grid mt", {'show-blocks': !_ctx.listView}])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.documents, (document) => {
                            return (_openBlock(), _createBlock(_component_document_block, {
                              key: document.id,
                              document: document,
                              blockType: _ctx.listView ? _ctx.blockTypes.row : _ctx.blockTypes.block,
                              onShowVersionDetail: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setVersionDetail($event))),
                              onShowBatchDetail: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setBatchDetail($event))),
                              onShowRelatedDocuments: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showRelatedDocuments($event)))
                            }, null, 8, ["document", "blockType"]))
                          }), 128))
                        ], 2)
                      ]))
                    }), 128))
                  ]))
          ])
        ]),
        _: 1
      })
    ]),
    (_ctx.selectedDocuments.length > 0)
      ? (_openBlock(), _createBlock(_component_selected_documents, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showVersionDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            (_ctx.showVersionDetails)
              ? (_openBlock(), _createBlock(_component_document_version_details, {
                  key: 0,
                  detailType: _ctx.documentDetailType.version,
                  "detail-document": _ctx.detailDocument,
                  onHide: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showVersionDetails = false))
                }, null, 8, ["detailType", "detail-document"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showBatchDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            (_ctx.showBatchDetails)
              ? (_openBlock(), _createBlock(_component_document_version_details, {
                  key: 0,
                  detailType: _ctx.documentDetailType.batch,
                  "detail-document": _ctx.detailDocument,
                  onHide: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showBatchDetails = false))
                }, null, 8, ["detailType", "detail-document"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}